__turbopack_context__.v({
  "active": "BzsI0a_active",
  "banners": "BzsI0a_banners",
  "button": "BzsI0a_button",
  "content": "BzsI0a_content",
  "contentHidden": "BzsI0a_contentHidden",
  "fullWidth": "BzsI0a_fullWidth",
  "iconContainer": "BzsI0a_iconContainer",
  "middleIconContainer": "BzsI0a_middleIconContainer",
  "neutral": "BzsI0a_neutral",
  "neutralOutline": "BzsI0a_neutralOutline",
  "neutralText": "BzsI0a_neutralText",
  "primary": "BzsI0a_primary",
  "primaryOutline": "BzsI0a_primaryOutline",
  "primaryText": "BzsI0a_primaryText",
  "secondary": "BzsI0a_secondary",
  "secondaryOutline": "BzsI0a_secondaryOutline",
  "secondaryText": "BzsI0a_secondaryText",
  "tertiary": "BzsI0a_tertiary",
  "tertiaryOutline": "BzsI0a_tertiaryOutline",
  "tertiaryText": "BzsI0a_tertiaryText",
  "textInherit": "BzsI0a_textInherit",
  "white": "BzsI0a_white",
  "whiteOutline": "BzsI0a_whiteOutline",
  "whiteText": "BzsI0a_whiteText",
});
